import styled from "styled-components";
import { colors, breakpoints } from "definitions";
import { addOpacityToColor } from "helpers";
import { Container } from "basics/cards";

// La tarjeta base tiene alto fijo (10rem) pensado para una línea de texto: con
// los roles y los premios del jurado como etiquetas, crece con el contenido.
export const UserContainer = styled(Container)`
  height: auto;
  min-height: 10rem;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  min-width: 0;
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  column-gap: 1.2rem;
  row-gap: 0.2rem;
`;

export const Name = styled.span`
  font-weight: bold;
  font-size: 1.6rem;
  color: #333333;
`;

export const Email = styled.span`
  font-size: 1.4rem;
  color: #666666;
  overflow-wrap: anywhere;
`;

// Rótulo a la izquierda y etiquetas a la derecha: si los premios ocupan más
// de una línea, la segunda queda alineada con la primera y no bajo el rótulo.
export const ChipRow = styled.div`
  display: grid;
  grid-template-columns: 7rem minmax(0, 1fr);
  align-items: start;
  column-gap: 0.6rem;
  row-gap: 0.4rem;

  ${breakpoints.phablet} {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
`;

export const ChipLabel = styled.span`
  padding-top: 0.4rem;
  font-size: 1.2rem;
  font-weight: 700;
  color: #7a8494;
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

export const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0.3rem 0.9rem;
  border-radius: 999px;
  font-size: 1.25rem;
  line-height: 1.4;
  background: ${({ $muted }) =>
    $muted ? "#F2F4F7" : addOpacityToColor(colors.background.gray, 0.1)};
  color: ${({ $muted }) => ($muted ? "#7A8494" : colors.background.gray)};
`;
